declare namespace $ {

	type $mol_text__text_bog_pazzle_play_1 = $mol_type_enforce<
		ReturnType< $bog_pazzle_play['time'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_pazzle_play_2 = $mol_type_enforce<
		ReturnType< $bog_pazzle_play['moves_label'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_check_box__title_bog_pazzle_play_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__hint_bog_pazzle_play_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['hint'] >
	>
	type $mol_check_box__checked_bog_pazzle_play_5 = $mol_type_enforce<
		ReturnType< $bog_pazzle_play['peek'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_bog_pazzle_play_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_pazzle_play_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_pazzle_play_8 = $mol_type_enforce<
		ReturnType< $bog_pazzle_play['again'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_pazzle_play_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_pazzle_play extends $mol_view {
		Clock( ): $mol_text
		moves_label( ): string
		Moves( ): $mol_text
		Filler( ): $mol_view
		Peek_toggle( ): $mol_check_box
		Again( ): $mol_button_minor
		Toolbar( ): $mol_view
		moves( ): number
		time( ): string
		peek( next?: boolean ): boolean
		again( next?: any ): any
		Game( ): $bog_pazzle_board
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=play.view.tree.d.ts.map